import { createTheme, darken, lighten } from '@mui/material/styles'
import themeBase from './themeBase'

export const lightTheme = createTheme(themeBase(), {
  palette: {
    primary: {
      main: '#424F76',
      light: lighten('#424F76', 0.2),
      dark: darken('#424F76', 0.2),
      contrastText: '#fff',
    },
    secondary: {
      main: '#b4515e',
      light: lighten('#b4515e', 0.2),
      dark: darken('#b4515e', 0.2),
    },
    background: {
      default: '#fefeff',
      paper: '#f2f2f2',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0,0,0.38)',
    },
    success: {
      main: '#b5e4ca',
      contrastText: '#f1f1f1',
    },
    divider: '#e2e3e4',
  },
})

export default lightTheme
